import { makeObservable, observable, action } from 'mobx';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import { defaultMinOdd } from '../enums/gameConstants';
import { gameStore } from './gameStore';

class BetDataStore {
  betsSectionsInitialData = {
    isAutoBet: false,
    selectedAutoBetCount: null,
    isAutoCashOut: false,
    autoCashOutOdd: defaultMinOdd,
    betAmount: null,
  };

  betsSectionsData = {};

  constructor() {
    makeObservable(this, {
      betsSectionsInitialData: observable,
      betsSectionsData: observable.deep,
      setInitialBetSectionsData: action.bound,
      setBetAmount: action.bound,
      autoCashOutToggle: action.bound,
      setAutoCashOutOdd: action.bound,
      setIsAutoBet: action.bound,
      selectAutoBetCount: action.bound,
      setReadyForAutoBet: action.bound,
      resetBetData: action.bound,
      autoBetsAndAutoCashOutsTurnOf: action.bound,
      stopAllAutoBet: action.bound,
    });
  }

  setInitialBetSectionsData(betsSectionsInitialData) {
    this.betsSectionsData = betsSectionsInitialData;
  }

  setReadyForAutoBet(bool, gameType) {
    this.betsSectionsData[gameType].readyForAutoBet = bool;
  }

  decreaseAutoBetCount(gameTypeId) {
    this.betsSectionsData[gameTypeId].selectedAutoBetCount -= 1;
    if (this.betsSectionsData[gameTypeId].selectedAutoBetCount === 0) {
      this.betsSectionsData[gameTypeId].selectedAutoBetCount = null;
      this.setIsAutoBet(false, gameTypeId);
    }
  }

  stopAllAutoBet() {
    gameStore.allGameTypes.forEach((gameTypeId) => {
      this.betsSectionsData[gameTypeId].selectedAutoBetCount = null;
      this.betsSectionsData[gameTypeId].isAutoBet = false;
    });
  }

  setIsAutoBet(bool, gameTypeId) {
    if (!bool) {
      this.betsSectionsData[gameTypeId].selectedAutoBetCount = null;
    }
    this.betsSectionsData[gameTypeId].isAutoBet = bool;
  }

  selectAutoBetCount(value, gameTypeId) {
    this.betsSectionsData[gameTypeId].selectedAutoBetCount = value;
  }

  setBetAmount(betAmount, gameTypeId) {
    if (gameTypeId) {
      this.betsSectionsData[gameTypeId].betAmount = betAmount;
    } else {
      const gameTypeId = gameStore.activeGameType;
      this.betsSectionsData[gameTypeId].betAmount = betAmount;
    }
  }

  getBetData(gameTypeId) {
    return this.betsSectionsData[gameTypeId];
  }

  setAutoCashOutOdd(odd, gameTypeId) {
    if (gameTypeId) {
      this.betsSectionsData[gameTypeId].autoCashOutOdd = odd;
    } else {
      const gameTypeId = gameStore.activeGameType;
      this.betsSectionsData[gameTypeId].autoCashOutOdd = odd;
    }
  }

  autoCashOutToggle(gameTypeId) {
    this.betsSectionsData[gameTypeId].isAutoCashOut =
      !this.betsSectionsData[gameTypeId].isAutoCashOut;
  }

  autoBetsAndAutoCashOutsTurnOf() {
    gameStore.allGameTypes.forEach((gameTypeId) => {
      this.betsSectionsData[gameTypeId].isAutoCashOut = false;
      this.betsSectionsData[gameTypeId].isAutoBet = false;
      this.betsSectionsData[gameTypeId].selectedAutoBetCount = null;
    });
  }

  resetBetData(allGameTypes) {
    const { defaultBetAmount, minBet } = gameConfigStore.limits;
    allGameTypes.forEach((gameTypeId) => {
      this.betsSectionsData[gameTypeId] = {
        ...this.betsSectionsData[gameTypeId],
        ...this.betsSectionsInitialData,
        betAmount: defaultBetAmount || minBet,
      };
    });
  }
}

export const betDataStore = new BetDataStore();
